import * as React from "react";
import Svg, { Path } from "react-native-svg";

function EditIcon(props) {
  return (
    <Svg
      width={props.width || 20}
      height={props.height || 20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <Path
        d="M2.5 14.55v2.534c0 .233.183.416.417.416H5.45a.391.391 0 00.292-.125l9.1-9.091-3.125-3.125-9.092 9.091a.41.41 0 00-.125.3zm14.758-8.683a.83.83 0 000-1.175l-1.95-1.95a.83.83 0 00-1.175 0l-1.525 1.525 3.125 3.125 1.525-1.525z"
        fill="#000"
        fillOpacity={0.86}
      />
    </Svg>
  );
}

export default EditIcon;
